<template>
    <div :class="{'share_wrap':true,'share_wrap_fixed':isFixed,'share-box':sampleroom==2}">
        <button @click="showGuide">分享客户</button>
        <button @click="showGuideUser" v-if="sampleroom==2">内部分享</button>
        <div v-show="$store.state.isShowShareTips" class="guide" @click.stop="showGuide">
            <img class="share_hand" src="~@/assets/images/user/housev2/share_hand.png"
                 alt="手"/>
            <div class="share_hint">
                <img class="share_icon" src="~@/assets/images/user/housev2/share_icon.png" alt="分享"/>
                <p>点击 “...” 去分享</p>
            </div>
        </div>
    </div>
</template>

<script>
import {getWxSingleConfig} from "@/js/wx.js";
import {getReportShare ,getReportShareUser} from "@/js/member/mynews/index.js";
import {shareInfoTitle} from "@/js/house/index.js";
import URLAPI from "@/libsV2/urlApi";

export default {
    name: "share",
    props: {
        trackAction: {
            type: String,
            default: '',
        },
        isFixed: {
            type: Boolean,
            default: false,
        },
        isHouse: {
            type: Boolean,
            default: true,
        },
        isShowName: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "交付在线"
        }
    },
    data() {
        return {
            show: false,
            objShareData:{},
            sampleroom:0,
        }
    },
    created() {
        this.sampleroom=this.$route.query.sampleroom
        getWxSingleConfig().then((res) => {
            wx.ready(() => {
                wx.hideMenuItems({
                    menuList: ["menuItem:share:wechat", "menuItem:share:timeline", "menuItem:copyUrl"]
                });
            })
        })
    },
    mounted() {
    },
    methods: {
        setShare(id = '',type) {
            // alert(this.$storage.getStorage('user_id'))
            // let objData = this.$storage.getStorage('sampleroom_info');
            if(type==2){
                this.objShareData.share_link=this.objShareData.share_link+`&shareId=${id}`
            }else if(type==3){
                this.objShareData.share_link=this.objShareData.share_link+`&shareIdUser=${id}`
            }
            console.log(this.objShareData,'分享数据')
            getWxSingleConfig(this.objShareData).then((res) => {
                wx.ready(() => {
                    /*wx.showMenuItems({
                        menuList: ["menuItem:share:appMessage", "menuItem:share:wechat"]
                    });*/
                })
            })
        },
        // 分享给客户
        showGuide() {
            if (this.$store.state.isShowShareTips) {
                this.$store.commit('editShowShareTips',false)
            } else {
                let shareData = {
                    share_source: this.$storage.getStorage('share_source') || 'ant',
                    project_uuid: this.$storage.getStorage('project_uuid') || this.$route.query.projectmgnid || this.$route.query.project_uuid || '',
                }
                if(this.$route.query.form=='wxwork'){
                    shareData.share_source='wxwork'
                }
                // 判断是否是需要分享那个页面打开那个页面的路径
                let data={}
                let sharePath = this.$router.history.current.path
                let contract_id = this.$storage.getStorage('contract_id') || this.$route.query.contract_id || this.$route.query.contractid || this.$route.query.contractId
                let company_id = this.$storage.getStorage('company_id') || this.$route.query.company_id
                let sharePersonId = this.$storage.getStorage('user_id')
                let restrict = this.$route.query.restrict
                let is_build_completed = this.$route.query.is_build_completed
                let is_completed = this.$route.query.is_completed
                let form = this.$storage.getStorage('share_source') == 'user'?'dossier':''
                let project_uuid =this.$storage.getStorage('project_uuid') || this.$route.query.projectmgnid || this.$route.query.project_uuid
                this.$common.pushEvent(this.trackAction, project_uuid)
                if(sharePath=="/member/v2/process/index" || sharePath=="/member/v2/process/detail"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    let link=''
                    if(sharePath=="/member/v2/process/index"){
                        if(this.$route.query.form=='wxwork'){
                            link = `${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&sharePersonId=${sharePersonId}&form=wxwork&contractid=${contract_id}`
                        }else{
                            link = `${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&sharePersonId=${sharePersonId}&form=${form}&contractid=${contract_id}`
                        }
                    }else if(sharePath=="/member/v2/process/detail"){
                        let rule_report_id = this.$storage.getStorage('nRuleReportId')
                        if(this.$route.query.form=='wxwork'){
                            link = `${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&sharePersonId=${sharePersonId}&form=wxwork&id=${rule_report_id}&contractid=${contract_id}`
                        }else{
                            link = `${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&sharePersonId=${sharePersonId}&form=${form}&id=${rule_report_id}&contractid=${contract_id}`
                        }
                    }
                    data.share_link=link
                }else if(sharePath=="/member/v2/contract/survey"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    if(this.$route.query.form=='wxwork'){
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&changeId=${this.$route.query.changeId}&contractId=${contract_id}&form=wxwork`
                    }else{
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&changeId=${this.$route.query.changeId}&contractId=${contract_id}&form=${form}`
                    }
                }else if(sharePath=="/member/v2/programme/index"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    if(this.$route.query.form=='wxwork'){
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&form=wxwork&accountid=${this.$route.query.accountid}&contractid=${contract_id}&systemuserid=${this.$route.query.systemuserid}`
                    }else{
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?projectmgnid=${project_uuid}&form=${form}&accountid=${this.$route.query.accountid}&contractid=${contract_id}&systemuserid=${this.$route.query.systemuserid}`
                    }
                }else if(sharePath=="/member/v2/evaluation/index"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    if(this.$route.query.form=='wxwork'){
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&form=wxwork&sharePersonId=${sharePersonId}&contractid=${contract_id}`
                    }else{
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&sharePersonId=${sharePersonId}&form=${form}&contractid=${contract_id}`
                    }
                }else if(sharePath=="/member/v2/evaluate/finish"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    if(this.$route.query.form=='wxwork'){
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&form=wxwork&sharePersonId=${sharePersonId}&company_id=${company_id}&contract_id=${contract_id}`
                    }else{
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&sharePersonId=${sharePersonId}&form=${form}&company_id=${company_id}&contract_id=${contract_id}`
                    }
                }else if(sharePath=="/member/v2/ievaluate/evaluate"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    if(this.$route.query.form=='wxwork'){
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&form=wxwork&sharePersonId=${sharePersonId}&company_id=${company_id}&contract_id=${contract_id}&restrict=${restrict}&is_completed=${is_completed}&is_build_completed=${is_build_completed}`
                    }else{
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&sharePersonId=${sharePersonId}&form=${form}&company_id=${company_id}&contract_id=${contract_id}&restrict=${restrict}&is_completed=${is_completed}&is_build_completed=${is_build_completed}`
                    }
                }else if(sharePath=="/member/v2/team/index"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    if(this.$route.query.form=='wxwork'){
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&form=wxwork&project_id=${project_uuid}&contractid=${contract_id}`
                    }else{
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&form=${form}&project_id=${project_uuid}&contractid=${contract_id}`
                    }
                }else if(sharePath=="/member/v2/mynews/index"){
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    }
                    if(this.$route.query.form=='wxwork'){
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&form=wxwork&project_id=${project_uuid}&accountid=${this.$route.query.accountid}&contractid=${contract_id}&systemuserid=${this.$route.query.systemuserid}`
                    }else{
                        data.share_link=`${window.location.protocol}//${window.location.host}${sharePath}?project_uuid=${project_uuid}&form=${form}&project_id=${project_uuid}&accountid=${this.$route.query.accountid}&contractid=${contract_id}&systemuserid=${this.$route.query.systemuserid}`
                    }
                }else{
                    data = {
                        share_friend_desc: '施工全流程在线交付 有源可溯',
                        share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                        share_link: `${window.location.protocol}//${window.location.host}/member/v2/index/index?form=${form}&sharePersonId=${sharePersonId}&track_action=${this.trackAction}&track_id=${project_uuid}&track_uuid=${sessionStorage.getItem('page_uuid')}&contractid=${contract_id}&projectmgnid=${project_uuid}`,
                        // share_link: `${window.location.href}${window.location.search != ''?'&':'?'}shareId=${id}&sharePersonId=${this.$storage.getStorage('user_id')}&track_action=${this.trackAction}&track_id=${this.$storage.getStorage('project_uuid')}&track_uuid=${sessionStorage.getItem('page_uuid')}`,
                    }
                }
                if(project_uuid){
                    this.$store.commit('loadSwitch',true)
                    shareInfoTitle({projectmgnid:project_uuid}).then(res=>{
                        this.$store.commit('loadSwitch',false)
                        console.log(this.isShowName,res.data.data.result.project.new_house,'标题')
                        data.share_friend_title=(this.isShowName?this.title:(res.data.data.result.project.new_house || this.title) ) + '-' +document.title
                        this.objShareData=data
                        shareData.url=data.share_link
                        shareData.is_qw_share=this.sampleroom==3?1:0
                        console.log(data,'log1')
                        getReportShare(shareData).then(res => {
                            this.setShare(res.data.data.result.id,2);
                        })
                        // this.show = true;
                        this.$store.commit('editShowShareTips',true)
                        setTimeout(()=>{
                            this.$store.commit('editShowShareTips',false)
                        },3000)
                    })
                }else{
                    data.share_friend_title=(this.isShowName?this.title:(res.data.data.result.project.new_house || this.title) ) + '-' +document.title
                    this.objShareData=data
                    shareData.url=data.share_link
                    shareData.is_qw_share=this.sampleroom==3?1:0
                    console.log(data,'log3')
                    getReportShare(shareData).then(res => {
                        this.setShare(res.data.data.result.id,2);
                    })
                    // this.show = true;
                    this.$store.commit('editShowShareTips',true)
                    setTimeout(()=>{
                        this.$store.commit('editShowShareTips',false)
                    },3000)
                }
            }
        },
        // 内部分享
        showGuideUser(){
            if (this.$store.state.isShowShareTips) {
                // this.show = false;
                this.$store.commit('editShowShareTips',false)
            } else {
                let shareData = {
                    share_source: this.$storage.getStorage('share_source') || 'ant',
                    projectmgnid: this.$storage.getStorage('project_uuid')|| this.$route.query.projectmgnid || this.$route.query.project_uuid || '',
                }
                let form = this.$storage.getStorage('share_source') == 'user'?'dossier':''
                let sharePersonId = this.$storage.getStorage('user_id')
                let accountid= this.$route.query.accountid
                let contractid= this.$route.query.contractid
                let systemuserid= this.$route.query.systemuserid
                let data = {
                    share_friend_title:(this.$storage.getStorage('accountNewName') || this.title) + '-' +document.title,
                    share_friend_desc: '施工全流程在线交付 有源可溯',
                    share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                    share_link: `${window.location.protocol}//${window.location.host}/member/v2/index/index?sampleroom=3&accountid=${accountid}&contractid=${contractid}&systemuserid=${systemuserid}&form=${form}`,
                }
                this.objShareData=data
                shareData.share_url=data.share_link
                getReportShareUser(shareData).then(res => {
                    this.setShare(res.data.data.result.share_id,3);
                })
                // this.show = true;
                this.$store.commit('editShowShareTips',true)
                setTimeout(()=>{
                    this.$store.commit('editShowShareTips',false)
                },3000)
            }
        },
    }
}
</script>

<style lang="scss" scoped>

.share_wrap {
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    background: #ffffff;
    border-radius: 20px 20px 0 0;

    button {
        width: 686px;
        height: 72px;
        background: #355D4B;
        border-radius: 36px;
        margin: 0 auto;
        display: block;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 72px;
    }
}
.share-box{
    display: flex;
    justify-content: space-around;
    button{
        width: 48%;
    }
}
.guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 99999;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0.6);

    .share_hand {
        width: 90px;
        height: 121px;
        margin: 25px 10px 0 auto;
        display: block;
    }

    .share_hint {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        p {
            font-size: 43px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 48px;
            text-align: center;
        }
    }

    .share_icon {
        width: 108px;
        height: 108px;
        display: block;
        margin: 0 auto 65px;
    }
}

.share_wrap_fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
}
</style>
